module.exports = __webpack_public_path__ + "img/13.b0d92f70.png";